/*@ngInject*/
const DataItemsController = function ($rootScope, $scope, $stateParams,
                                      $timeout, $document, localization, dataSetType,
                                      coreConstant, dataSetManagementUtil, dataItemSortingConstant,
                                      configurationConstant, dataSetEditorModel,
                                      currentUserModel, authorizationConstants) {

    var timeoutList = [];

    // UMS-20495 workaround
    try {
        $stateParams.dataSetName = decodeURIComponent($stateParams.dataSetName);
    }
    catch (exception){
        // do nothing
    }

    function init() {
        localization.getTranslationByKey('dataItems').then(function (translation) {
            var dataSet = dataSetEditorModel.getDataSet($stateParams.dataSetName);

            $scope.viewModel = {
                isCustomDynamicDataSet: parseInt($stateParams.type) === dataSetType.CUSTOM,
                isProductOrFieldDependentDynamicDataSet: parseInt($stateParams.type) === dataSetType.PRODUCT_FIELD_DEPENDENT,
                isApplySortingEnabled: false,
                dataSetName: $stateParams.dataSetName,
                isReadOnly : !currentUserModel.hasAuthorization(authorizationConstants.MANAGE_DATASETS),
                dataItemsGroups : []
            };

            $scope.timeLastModified = new Date().getTime();

            buildDataItemsGroupings(dataSet);

            initGroupSortingChoices(translation, dataItemSortingConstant.LABEL_ASC);

            timeoutList.push($timeout(function () {
                $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, $scope.viewModel.groupSortingDropdownSelectedValue);
            }, 0));


        });
    }

    function buildDataItemsGroupings(dataSet) {
        var dataItemsGroups = {};

        if (!_.isNil(dataSet)) {
            // Organize the dataItems into their various 'grouping' and sort by 'ordering'
            // TODO is ordering guaranteed when returned from server? If so, we don't have to do the _.orderBy below

            if(_.isEmpty(dataSet.items)) {
                if (_.isEmpty($scope.viewModel.dataItemsGroups)) {
                    $scope.viewModel.dataItemsGroups.push({
                        id: dataSetManagementUtil.generateUUID(),
                        name: '',
                        dataSetName: $stateParams.dataSetName,
                        items: []
                    });
                }
            } else {

                _.each(dataSet.items, function (dataItem) {
                    if (_.isNil(dataItem.grouping)) {
                        dataItem.grouping = '';
                    }

                    if (!_.has(dataItemsGroups, dataItem.grouping)) {
                        dataItemsGroups[dataItem.grouping] = [];
                    }

                    dataItemsGroups[dataItem.grouping].push({
                        id: dataSetManagementUtil.generateUUID(),
                        dataSetName: $stateParams.dataSetName,
                        dataItem: dataItem
                    });
                });

                _.forOwn(dataItemsGroups, function (dataItemViews, grouping) {
                    dataItemsGroups[grouping] = _.orderBy(dataItemViews, 'dataItem.ordering');
                });

                $scope.viewModel.dataItemsGroups = _.transform(dataItemsGroups, function (result, dataItemViews, dataItemsGroupName) {
                    var groupId = dataSetManagementUtil.generateUUID();

                    _.each(dataItemViews, function (dataItemView) {
                        dataItemView.groupId = groupId;
                    });

                    result.push({
                        id: groupId,
                        name: dataItemsGroupName,
                        dataSetName: $stateParams.dataSetName,
                        items: dataItemViews
                    });
                }, []);
            }
        }
    }

    function initGroupSortingChoices(translation, selectedValue) {
        $scope.viewModel.groupSortingChoices = [{
            name: _.get(translation, 'sorting.labelAscLabel'),
            value: dataItemSortingConstant.LABEL_ASC
        }, {
            name: _.get(translation, 'sorting.labelDescLabel'),
            value: dataItemSortingConstant.LABEL_DESC
        }, {
            name: _.get(translation, 'sorting.valueAscLabel'),
            value: dataItemSortingConstant.VALUE_ASC
        }, {
            name: _.get(translation, 'sorting.valueDescLabel'),
            value: dataItemSortingConstant.VALUE_DESC
        }];

        $scope.viewModel.groupSortingDropdownSelectedValue = _.find($scope.viewModel.groupSortingChoices, function (item) {
            return item.value === selectedValue;
        });
    }

    $scope.onApplySortingClicked = function () {
        var sortProperty,
            ascending,
            preSortedDataItemGroups = [];

        switch ($scope.viewModel.groupSortingDropdownSelectedValue.value) {
            case dataItemSortingConstant.LABEL_ASC:
                sortProperty = 'name';
                ascending = true;
                break;

            case dataItemSortingConstant.LABEL_DESC:
                sortProperty = 'name';
                ascending = false;
                break;

            case dataItemSortingConstant.VALUE_ASC:
                sortProperty = 'value';
                ascending = true;
                break;

            case dataItemSortingConstant.VALUE_DESC:
                sortProperty = 'value';
                ascending = false;
                break;
        }

        _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            var numericSort = true;

            // Filter out invalid rows before sorting.
            dataItemsGroup.items = _.filter(dataItemsGroup.items, function (dataItemView) {
                var validDataItemForEvaluation = dataSetManagementUtil.isValidDataItemForEvaluation(dataItemView.dataItem);

                if (!validDataItemForEvaluation) {
                    dataSetEditorModel.removeDataItem($stateParams.dataSetName, dataItemView.dataItem);
                }

                return validDataItemForEvaluation;
            });

            preSortedDataItemGroups.push(_.cloneDeep(dataItemsGroup));

            _.each(dataItemsGroup.items, function (dataItemView) {
                if (isNaN(_.toNumber(_.replace(dataItemView.dataItem[sortProperty], ',', '')))) {
                    numericSort = false;
                    return false;
                }
            });

            if (numericSort) {
                dataItemsGroup.items = _.sortBy(dataItemsGroup.items, function (dataItemView) {
                    return _.toNumber(_.replace(dataItemView.dataItem[sortProperty], ',', ''));
                });

                if (!ascending) {
                    dataItemsGroup.items = _.reverse(dataItemsGroup.items);
                }
            } else {
                dataItemsGroup.items = _.orderBy(dataItemsGroup.items, 'dataItem.' + sortProperty, ascending ? 'asc' : 'desc');
            }
        });

        calculateOrdering();

        if (!_.isEqual(preSortedDataItemGroups, $scope.viewModel.dataItemsGroups)) {
            dataSetEditorModel.setUnsavedChanges($scope.viewModel.dataSetName, /*hasUnsavedChanges*/ true);
            $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
        }
        $scope.timeLastModified = new Date().getTime();
    };

    $scope.onDataItemsGroupDeleteClicked = function (dataItemsGroupId) {
        var dataItemsGroupIndex = _.findIndex($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            return dataItemsGroup.id === dataItemsGroupId;
        });
        _.each($scope.viewModel.dataItemsGroups[dataItemsGroupIndex].items, function (dataItemView) {
            dataSetEditorModel.removeDataItem($stateParams.dataSetName, dataItemView.dataItem);
        });
        $scope.viewModel.dataItemsGroups.splice(dataItemsGroupIndex, 1);

        calculateOrdering();
        dataSetEditorModel.setUnsavedChanges($scope.viewModel.dataSetName, /*hasUnsavedChanges*/ true);
        $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
    };

    $scope.onAddGroupClicked = function () {
        $scope.viewModel.dataItemsGroups.push({
            id: dataSetManagementUtil.generateUUID(),
            name: '',
            dataSetName: $stateParams.dataSetName,
            items: []
        });
        dataSetEditorModel.setUnsavedChanges($scope.viewModel.dataSetName, /*hasUnsavedChanges*/ true);
        $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
    };

    $scope.onDataItemsGroupSelectedOrUnselected = function (dataItemsGroupId) {
        // Unselect all data items groups *other than* the group id passed in, also unselect all data items
        _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            if (dataItemsGroup.id !== dataItemsGroupId) {
                dataItemsGroup.selected = false;
            }

            _.each(dataItemsGroup.items, function (dataItemView) {
                dataItemView.selected = false;
            });
        });
    };

    $scope.onDataItemSelectedOrUnselected = function (dataItemsGroupId) {
        // Unselect all data items in groups *other than* the group id passed in, also unselect all data items groups
        _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            dataItemsGroup.selected = false;

            if (dataItemsGroup.id !== dataItemsGroupId) {
                _.each(dataItemsGroup.items, function (dataItemView) {
                    dataItemView.selected = false;
                });
            }
        });

        $scope.timeLastModified = new Date().getTime();
    };

    $scope.handleDeleteKeyEventAction = function () {
        deleteSelectedDataItems();
        deleteSelectedDataItemsGroups();
    };

    $scope.onTextInputFocused = function () {
        // Whenever a text input is focused (from the dataItemsGroups, unselect *everything*
        _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            dataItemsGroup.selected = false;

            _.each(dataItemsGroup.items, function (dataItemView) {
                dataItemView.selected = false;
            });
        });
    };

    $scope.$on(configurationConstant.event.DATA_SET_ITEM_DRAG_DROP, function (event, dragDropConfiguration) {
        var dragDataItemsGroupId = dragDropConfiguration.dragDataItemsGroupId,
            dropDataItemId = dragDropConfiguration.dropDataItemId,
            dropDataItemsGroupId = dragDropConfiguration.dropDataItemsGroupId,
            type = dragDropConfiguration.type,
            dragDataItemsGroupIndex,
            dropDataItemIndex,
            dropDataItemsGroupIndex,
            dragDataItemIndex,
            dragDataItemsGroup,
            dragDataItemViews,
            dropDataItemsGroup,
            dataItemMoved;

        dragDataItemsGroupIndex = _.findIndex($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            return dataItemsGroup.id === dragDataItemsGroupId;
        });
        dragDataItemsGroup = $scope.viewModel.dataItemsGroups[dragDataItemsGroupIndex];
        // Find the dragged items
        dragDataItemViews = _.filter(dragDataItemsGroup.items, function (dataItemView) {
            return dataItemView.selected === true;
        });

        dragDataItemIndex = _.findIndex(dragDataItemsGroup.items, function (dataItemView) {
            return dataItemView.selected === true;
        });

        // Remove the dragged items
        dragDataItemsGroup.items = _.filter(dragDataItemsGroup.items, function (dataItemView) {
            return dataItemView.selected === false;
        });

        dropDataItemsGroupIndex = _.findIndex($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            return dataItemsGroup.id === dropDataItemsGroupId;
        });
        dropDataItemsGroup = $scope.viewModel.dataItemsGroups[dropDataItemsGroupIndex];
        dropDataItemIndex = _.findIndex(dropDataItemsGroup.items, function (dataItemView) {
            return dataItemView.id === dropDataItemId;
        });
        if (type === configurationConstant.dataSet.INSERT_AFTER) {
            dropDataItemIndex++;
        }

        dataItemMoved = dragDataItemIndex !== dropDataItemIndex;

        // Insert the dragged item
        _.each(dragDataItemViews, function (dataItemView) {
            dataItemView.groupId = dropDataItemsGroup.id;
            dataItemView.dataItem.grouping = dropDataItemsGroup.name;
            dropDataItemsGroup.items.splice(dropDataItemIndex++, 0, dataItemView);
        });

        calculateOrdering();

        if (dataItemMoved) {
            dataSetEditorModel.setUnsavedChanges($scope.viewModel.dataSetName, /*hasUnsavedChanges*/ true);
            $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
        }

        $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEM_GROUP_SET_SHIFT_SELECT_PIVOT, _.first(dragDataItemViews));

        timeoutList.push($timeout(function () {
            $scope.timeLastModified = new Date().getTime();
        }, 0));
    });

    $scope.$on(configurationConstant.event.DATA_SET_ITEMS_GROUP_DRAG_DROP, function (event, dragDropConfiguration) {
        var dragDataItemsGroupId = dragDropConfiguration.dragDataItemsGroupId,
            dropDataItemsGroupId = dragDropConfiguration.dropDataItemsGroupId,
            type = dragDropConfiguration.type,
            dragDataItemsGroupIndex,
            dropDataItemsGroupIndex,
            dragDataItemsGroup;

        dragDataItemsGroupIndex = _.findIndex($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            return dataItemsGroup.id === dragDataItemsGroupId;
        });
        // Remove the dragged group
        dragDataItemsGroup = $scope.viewModel.dataItemsGroups.splice(dragDataItemsGroupIndex, 1)[0];

        dropDataItemsGroupIndex = _.findIndex($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            return dataItemsGroup.id === dropDataItemsGroupId;
        });
        if (type === configurationConstant.dataSet.INSERT_AFTER) {
            dropDataItemsGroupIndex++;
        }
        // Insert the dragged group
        $scope.viewModel.dataItemsGroups.splice(dropDataItemsGroupIndex, 0, dragDataItemsGroup);

        calculateOrdering();

        // check if the group moved to a new location
        if (dragDataItemsGroupIndex !== dropDataItemsGroupIndex) {
            dataSetEditorModel.setUnsavedChanges($scope.viewModel.dataSetName, /*hasUnsavedChanges*/ true);
            $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
        }

        timeoutList.push($timeout(function () {
            $scope.timeLastModified = new Date().getTime();
        }, 0));
    });

    $scope.$on(configurationConstant.event.DATA_SET_EDITOR_MODEL_UPDATED, function (event, dataSetName) {
        var dataSet;

        if ($stateParams.dataSetName === dataSetName) {
            dataSet = dataSetEditorModel.getDataSet(dataSetName);
            buildDataItemsGroupings(dataSet);
        }
    });

    $scope.$watch('viewModel.dataItemsGroups', function (newVal, oldVal) {
        var isDataSetValid,
            dataSet;

        // Determine if "Apply Sorting" button should be enabled
        $scope.viewModel.isApplySortingEnabled = false;
        _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            // Remove invalid rows before evaluation
            var items = _.filter(dataItemsGroup.items, function (dataItemView) {
                return dataSetManagementUtil.isValidDataItemForEvaluation(dataItemView.dataItem);
            });

            if (items.length >= 2) {
                $scope.viewModel.isApplySortingEnabled = true;
                return false;
            }
        });

        calculateOrdering();
        validateDataSet();

    }, true);

    function validateDataSet(){
        var previousValid = dataSetEditorModel.isValid($scope.viewModel.dataSetName),
            isDataSetValid = validateGroups() && validateDataItems();
        if($scope.viewModel.dataSetName) {
            dataSetEditorModel.setValid($scope.viewModel.dataSetName, isDataSetValid);
        }
        if(previousValid !== isDataSetValid){
            $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
        }

    }

    // A group is invalid if is has the same name as another group
    function validateGroups() {
        var groupNameToIds = {},
            invalidGroupIds = [],
            isValid = true;

        _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            if (_.isNil(groupNameToIds[dataItemsGroup.name])) {
                groupNameToIds[dataItemsGroup.name] = [dataItemsGroup.id];
            }
            else {
                groupNameToIds[dataItemsGroup.name].push(dataItemsGroup.id);
            }
        });

        //Find the invalid group ids.
        _.each(groupNameToIds, function (groupIds) {
            if (groupIds.length > 1) {
                invalidGroupIds = invalidGroupIds.concat(groupIds);
            }
        });

        _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            var isDataItemGroupValid = !_.includes(invalidGroupIds, dataItemsGroup.id);
            isValid = isDataItemGroupValid && isValid;
            setValidity('dataItemsGroup', isDataItemGroupValid, dataItemsGroup.id);
        });
        return isValid;
    }

    // A data item is invalid if it is not the last data item in a group and has a duplicate name or value,
    // or an empty name or value.
    function validateDataItems() {
        var dataItemNameToViewIds = {},
            dataItemValueToViewIds = {},
            invalidDataItemViewIds = [],
            isValid = true;

        // Build map of name/value to ids
        _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            var lastDataItemView = _.last(dataItemsGroup.items);

            _.each(dataItemsGroup.items, function (dataItemView) {
                if( _.isEmpty(dataItemView.dataItem.name) || _.isEmpty(dataItemView.dataItem.value)){
                    if(lastDataItemView !== dataItemView) {
                        invalidDataItemViewIds.push(dataItemView.id);
                    }
                    else if (!_.isEmpty(dataItemView.dataItem.name) || !_.isEmpty(dataItemView.dataItem.value) || !_.isNil(dataItemView.dataItem.defaultPrecedence)){
                        invalidDataItemViewIds.push(dataItemView.id);
                    }
                }
                if(!_.isEmpty(dataItemView.dataItem.name)) {
                    if (_.isNil(dataItemNameToViewIds[dataItemView.dataItem.name])) {
                        dataItemNameToViewIds[dataItemView.dataItem.name] = [dataItemView.id];
                    }
                    else {
                        dataItemNameToViewIds[dataItemView.dataItem.name].push(dataItemView.id);
                    }
                }
                if(!_.isEmpty(dataItemView.dataItem.value)) {
                    if (_.isNil(dataItemValueToViewIds[dataItemView.dataItem.value])) {
                        dataItemValueToViewIds[dataItemView.dataItem.value] = [dataItemView.id];
                    }
                    else {
                        dataItemValueToViewIds[dataItemView.dataItem.value].push(dataItemView.id);
                    }
                }
            });
        });

        // Find the invalid dataItem ids.
        _.each(dataItemNameToViewIds, function (dataItemIds, dataItemName) {
            if (dataItemIds.length > 1 || _.isEmpty(dataItemName)) {
                invalidDataItemViewIds = invalidDataItemViewIds.concat(dataItemIds);
            }
        });
        _.each(dataItemValueToViewIds, function (dataItemIds, dataItemValue) {
            if (dataItemIds.length > 1 || _.isEmpty(dataItemValue)) {
                invalidDataItemViewIds = invalidDataItemViewIds.concat(dataItemIds);
            }
        });

        _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            _.each(dataItemsGroup.items, function (dataItemView) {
                var isDataItemValid = !_.includes(invalidDataItemViewIds, dataItemView.id);
                isValid = isDataItemValid && isValid;
                setValidity('dataItem', isDataItemValid, dataItemsGroup.id, dataItemView.id);
            });
        });
        return isValid;
    }

    function setValidity(errorKey, isValid, groupId, dataItemViewId) {
        var formController = $scope.dataItemsForm['dataItemsGroup' + groupId];
        if (formController && dataItemViewId) {
            formController = formController['dataItemView' + dataItemViewId];
        }

        if (formController) {
            formController.$setValidity(errorKey, isValid);
        }
    }

    function deleteSelectedDataItems() {
        _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            dataItemsGroup.items = _.filter(dataItemsGroup.items, function (dataItemView) {
                var selected = dataItemView.selected;

                if (selected) {
                    dataSetEditorModel.removeDataItem($stateParams.dataSetName, dataItemView.dataItem);
                }

                return !selected;
            });
        });

        calculateOrdering();

        $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEM_GROUP_SET_SHIFT_SELECT_PIVOT, {});

        dataSetEditorModel.setUnsavedChanges($scope.viewModel.dataSetName, /*hasUnsavedChanges*/ true);
        $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);

        timeoutList.push($timeout(function () {
            $scope.timeLastModified = new Date().getTime();
        }, 0));
    };

    function deleteSelectedDataItemsGroups() {
        var dataItemsGroup = _.find($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            return dataItemsGroup.selected;
        });

        if (!_.isNil(dataItemsGroup) &&
            _.first($scope.viewModel.dataItemsGroups).id !== dataItemsGroup.id) { // Don't allow the first group to be deleted
            $scope.onDataItemsGroupDeleteClicked(dataItemsGroup.id);

            timeoutList.push($timeout(function () {
                $scope.timeLastModified = new Date().getTime();
            }, 0));
        }
    };

    function calculateOrdering() {
        var ordering = 0;

        // Make sure the 'ordering' of each data item is updated properly
        _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
            _.each(dataItemsGroup.items, function (dataItemView) {
                dataItemView.dataItem.ordering = ordering++;
            });
        });
    }

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });

    init();
};

angular.module('ums.configuration')
    .controller('dataItemsController', DataItemsController);
